import { render, staticRenderFns } from "./PluginCard.vue?vue&type=template&id=dcdfa56a&scoped=true&"
import script from "./PluginCard.vue?vue&type=script&lang=js&"
export * from "./PluginCard.vue?vue&type=script&lang=js&"
import style0 from "./PluginCard.vue?vue&type=style&index=0&id=dcdfa56a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcdfa56a",
  null
  
)

export default component.exports